import moment from 'moment'

export const computeRealShiftDates = (
  realTimeRange: string[],
  plannedTimeRange: string[]
) => {
  const [plannedStartTime] = plannedTimeRange
  const [realStartTime, realEndTime] = realTimeRange

  const plannedStart = moment(plannedStartTime)

  const realStart = moment(plannedStart).set({
    hour: parseInt(realStartTime.split(':')[0], 10),
    minute: parseInt(realStartTime.split(':')[1], 10)
  })

  if (realStart.isAfter(plannedStart)) {
    realStart.subtract(1, 'days')
  }

  // Ensure realStart is not before plannedStart by more than 12 hours (handle late-night cases)
  if (
    realStart.isBefore(plannedStart) &&
    plannedStart.diff(realStart, 'hours') > 12
  ) {
    realStart.add(1, 'days')
  }

  const realEnd = moment(plannedStart).set({
    hour: parseInt(realEndTime.split(':')[0], 10),
    minute: parseInt(realEndTime.split(':')[1], 10)
  })

  if (realEnd.isBefore(realStart)) {
    realEnd.add(1, 'days')
  }

  return {
    realStart: realStart.format(),
    realEnd: realEnd.format()
  }
}
